<template>
  <div class="row justify-center tariff-card-block">
    <!-- <div class="col-md-12 col-sm-8 col-12"> -->
    <h2 v-if="!delete_title" class="tariff-card-block_title mb-6 pt-7 pl-30 mb-sm-12 h1 fz46 text-center col-12 col-md-8 mt-md-0 mt-6">{{ $t('Тарифы') }}</h2>

    <!-- Карточки -->
    <div class="col-12 col-md-10 justify-center mt-50 mb-md-3 tariff-card-block_row" key="card">

      <div class="row justify-center align-start tariff-columns-wrap">
        <div v-metric="'TARIFF_CLICK-ON-RAZMESCHENIE'" class="col-md-3 col-sm-6 col-12 px-md-0 mb-9 mb-md-0">
          <div class="tariff-card tariff-card--free py-9 px-6">
            <h4 class="tariff-card__title pb-9">{{ $t('Размещение') }}</h4>
            <ul class="tariff-card__list py-9">
              <li class="tariff-card__item">{{ $t('Страница с информацией о компании на портале BIMLIB с видео и текстовой информацией') }}</li>
              <li class="tariff-card__item">{{ $t('Размещение неограниченного числа карточек моделей в BIM-библиотеке') }}</li>
              <li class="tariff-card__item">{{ $t('Создание персональных разделов – каталог производителя') }}</li>
              <li class="tariff-card__item">{{ $t('Доступность всех моделей производителя в плагине BIMLIB для САПР') }}</li>
              <li class="tariff-card__item">{{ $t('Широкие возможности встраивания информации из сформированной библиотеки на сторонних сайтах') }}</li>
              <li class="tariff-card__item">{{ $t('Статистика скачиваний и просмотров по размещенной информации в личном кабинете') }}</li>
            </ul>

            <span class="tariff-card__price tariff-card__price--free mb-6">{{ $t('Бесплатно') }}</span>
            <span>{{ $t('Доступен всем после регистрации') }}</span>
          </div>
        </div>
        <div v-metric="'TARIFF_CLICK-ON-BASIC'" class="col-md-3 col-sm-6 col-12 px-md-0 mb-9 mb-md-0">
          <div class="tariff-card py-9 px-6">
            <h4 class="tariff-card__title pb-9">{{ $t('Базовый') }}</h4>
            <ul class="tariff-card__list py-9">
              <li class="tariff-card__item">{{ $t('Уведомления о загрузках моделей на электронную почту с указанием контактных данных') }}</li>
              <li class="tariff-card__item">{{ $t('Прямая коммуникации с пользователями портала, взаимодействующими с моделями и цифровыми каталогами') }}</li>
              <li class="tariff-card__item">{{ $t('Размещение видеороликов на странице модели') }}</li>
              <li class="tariff-card__item">{{ $t('Блог компании в Читальном зале') }}</li>
            </ul>

            <p class="tariff-card__extends">{{ $t('+ Возможности тарифа «Размещение»') }}</p>

            <span class="tariff-card__price mb-3">{{ $t('60 000') }} <small class="tariff-card__price-small">{{ $t('РУБ. / ГОД') }}</small></span>
            <span class="d-block tariff-card__price-small ml-0 mb-9">{{ $t('45 000') }} {{ $t('руб. / полгода') }}</span>

            <bim-button v-metric="'TARIFF_CLICK-ON-BUTTON-BASIC'" @click="showModal = 'modal'" outline size="l" active-class="tariff-card__button" :label="$t('Выбрать')"/>
          </div>
        </div>
        <div v-metric="'TARIFF_CLICK-ON-INDIVIDUAL'" class="col-md-3 col-sm-6 col-12 px-md-0 mb-9 mb-md-0">
          <div class="tariff-card py-9 px-6">
            <h4 class="tariff-card__title pb-9">{{ $t('Индивидуальный') }}</h4>
            <ul class="tariff-card__list py-9">
              <li class="tariff-card__item">{{ $t('Написание уникальных статейных материалов на тему применения BIM-технологий') }}</li>
              <li class="tariff-card__item">{{ $t('Включение в электронную рассылку по аудитории портала') }}</li>
              <li class="tariff-card__item">{{ $t('Возможность размещения калькулятора продукции в плагине BIMLIB для САПР') }}</li>
              <li class="tariff-card__item">{{ $t('Приоритетная техническая поддержка') }}</li>
            </ul>

            <p class="tariff-card__extends">{{ $t('+ Возможности тарифа «Размещение»') }}</p>
            <p class="tariff-card__extends">{{ $t('+ Возможности тарифа «Базовый»') }}</p>

            <span class="tariff-card__price mb-3">{{ $t('120 000') }} <small class="tariff-card__price-small">{{ $t('РУБ. / ГОД') }}</small></span>
            <span class="d-block tariff-card__price-small ml-0 mb-9">{{ $t('90 000') }} {{ $t('руб. / полгода') }}</span>

            <bim-button v-metric="'TARIFF_CLICK-ON-BUTTON-INDIVIDUAL'" @click="showModal = 'modal'" outline size="l" active-class="tariff-card__button" :label="$t('Выбрать')"/>
          </div>
        </div>
        <div v-metric="'TARIFF_CLICK-ON-RESULTAT'" class="col-md-3 col-sm-6 col-12 px-md-0 mb-9 mb-md-0">
          <div class="tariff-card tariff-card--primary py-9 px-6">
            <h4 class="tariff-card__title pb-9">{{ $t('Результат') }}</h4>
            <ul class="tariff-card__list py-9">
              <li class="tariff-card__item">{{ $t('Персональный аккаунт менеджер,  задействованный в вашем успешном продвижении на портале') }}</li>
              <li class="tariff-card__item">{{ $t('Возможность привлечения экспертов BIMLIB в качестве спикеров на мероприятия') }}</li>
            </ul>

            <p class="tariff-card__extends">{{ $t('+ Возможности тарифа «Размещение»') }}</p>
            <p class="tariff-card__extends">{{ $t('+ Возможности тарифа «Базовый»') }}</p>
            <p class="tariff-card__extends">{{ $t('+ Возможности тарифа «Индивидуальный»') }}</p>

            <span class="tariff-card__price mb-9">{{ $t('180 000') }} <small class="tariff-card__price-small">{{ $t('РУБ. / ГОД') }}</small></span>
            <bim-button v-metric="'TARIFF_CLICK-ON-BUTTON-RESULTAT'" @click="showModal = 'modal'" color="luxury" size="l" active-class="tariff-card__button" :label="$t('Выбрать')"/>
          </div>
        </div>
      </div>
    </div>

    <p class="text-center fz14 mb-9">Скидки для членов <a href="http://natamac.ru/?from=bimlib.pro" target="_blank" rel="nofollow" class="d-inline link-main link-main--border-green link-main--solid-small">НОПСМ</a>. Подробности у наших менеджеров.</p>
    <modalTariff v-if="showModal === 'modal'" @close="showModal = 'close'" id="modal-tariff"/>
  </div>
</template>

<script>
  import modal from '../../athoms/Modal.vue'
  import modalTariff from './ModalTariff.vue'

  export default {
    components: { modal, modalTariff },
    // components: { modal },
    props: {
      delete_title: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        // checker: 'card',
        showModal: '',
        accordeonOne: true,
        accordeonBasic: false,
        accordeonVip: false,
        accordeonDesktop: true,
        windowWidth: document.documentElement.clientWidth
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './src/front_white/sass/components/settings';

  #tariff .tariff-card-block_row {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  #tariff .tariff-card-block {
    padding-right : 24px;
  }
  .checker--margin {
    margin-bottom : 2.5333rem;
  }

  .slide-fade-enter-active {
    transition : all 0.3s ease;
  }

  .slide-fade-leave-active {
    transition : all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter,
  .slide-fade-leave-to
    /* .slide-fade-leave-active до версии 2.1.8 */
  {
    transform : translateX(10px);
    opacity   : 0;
  }

  .check-btn {
    cursor : pointer;
  }

  .checker-block {
    position   : relative;

    color      : $text-main;
    min-width  : 222px;
    text-align : center;
  }

  .active-tariff {
    color : $active;
  }

  .scroll-bar {
    position         : absolute;
    bottom           : -0.9333rem;
    left             : 50%;

    width            : 100%;
    height           : 0.1333rem;

    background-color : $soft;
    transform        : translateX(-50%);

    transition       : all 0.5s;

    &:after {
      content          : '';
      position         : absolute;
      top              : 0;
      left             : 0;

      width            : 50%;
      height           : 0.1333rem;

      background-color : $active;
    }
  }

  .scroll-bar-active {
    &:after {
      left : 50%;
    }
  }

  .tariff-card {
    border-radius : 10px;
    &:hover {
      background-color : $primary-color-75;
      .tariff-card__extends {
        background-color : $primary-color-50;
        color: $black-color;
      }
    }
    &--primary {
      border: 1px dashed $luxury-color;
      .tariff-card__title {
        color : $luxury-color;
        border-color: $luxury-color;
      }
      &:hover {
        border-color: transparent;
        background-color : $luxury-color-10;
        .tariff-card__extends {
          background-color : $luxury-color-20;
        }
      }
    }
    &--free {
      .tariff-card__title {
        color : $black-color;
        border-color: $white-color-500;
      }
      &:hover {
        border-color: transparent;
        background : none;
      }
    }

    &__title {
      @include font-main(20px, bold, 1.3);
      border-bottom : 1px solid $active;
      color : $active;
    }
    &__item {
      @include font-main(14px, normal, 1.57, 0.2px);
      &:not(:last-child) {
        margin-bottom : 14px;
      }
    }
    &__extends {
      padding : 8px;
      border-radius : 4px;
      background-color : $primary-color-75;
      @include font-main(12px, normal, 1.83, 0.5px);
      color : $primary-color;
      margin-bottom : 14px;
      &:first-of-type {
        color : $black-color;
        background-color : $white-color-100;
      }
      &:last-of-type {
        margin-bottom : 32px;
      }
    }
    &__price {
      display : flex;
      align-items: baseline;
      @include font-main(24px, bold, 1.3);
      &-small {
        font-size : 12px;
        margin-left : 4px;
      }
      &--free {
        font-size : 20px;
      }
    }
    &__button {
      width : 100%;
      // background : transparent !important;
      transition: all .2s, color 0s !important;
      // &:hover {
      //   background : $primary-color !important;
      // }
    }
  }

</style>
